import { useEffect } from 'react';

import { deliveryAddressStore } from '~/components/ModalDeliveryAddress/DeliveryAddressStore';
import type { DeliveryAddress } from '~/stores/UserStore';

export const useSetMapCenter = (deliveryAddress: DeliveryAddress | null) => {
  useEffect(() => {
    if (deliveryAddress?.coordinates) {
      deliveryAddressStore.setMapCenter(deliveryAddress?.coordinates);
      deliveryAddressStore.setSelectedZone(
        deliveryAddressStore.getSelectedPolygon(deliveryAddress?.coordinates),
      );
    }
  }, [deliveryAddress]);
};
